import type { AbstractControl, ValidationErrors } from '@angular/forms';

export function resolutionDateOrderValidator(group: AbstractControl): ValidationErrors | null {
  const first = group.get('dateOfFirstReply')?.value as Date | null;
  const resolution = group.get('dateOfResolution')?.value as Date | null;
  if (!first || !resolution) return null;
  return resolution.getTime() < first.getTime() ? { dateOrder: true } : null;
}
